export interface SowValidationDetail { path: string; message: string }

export class SowRequestError extends Error {
  constructor(message: string, public details: SowValidationDetail[] = []) { super(message); }
}

export function sowFieldErrors(details: SowValidationDetail[]): Record<string, string> {
  return Object.fromEntries(details.map((d) => [d.path.replace(/^fields\./, ''), d.message]));
}

export async function readSowError(response: Response): Promise<SowRequestError> {
  const body = await response.json().catch(() => null) as { error?: { message?: string; details?: SowValidationDetail[] }; correlationId?: string } | null;
  const details = Array.isArray(body?.error?.details) ? body.error.details : [];
  const message = details.length ? 'Please correct the highlighted fields.'
    : body?.error?.message && body.error.message !== 'Internal server error' ? body.error.message
    : 'Document generation failed on the server. Your edits are preserved; please retry or share this opportunity with support.';
  return new SowRequestError(`${message}${body?.correlationId ? ` Reference: ${body.correlationId}` : ''}`, details);
}
